import { useDropdownState } from '../abstract/dropdown';

export function useLandSizeFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let { selected: landSize, onSelect: onLandSizeSelect, options: landSizeOptions } = useDropdownState({
    defaultOptions: config.landSizeOptions,
    defaultValue: query.landSize || config.landSizeDefault,
    filterKey: `landSize`,
    queryKey: `land`,
    setFilters,
    updateQuery,
  });

  return { landSize, landSizeOptions, onLandSizeSelect };
}
